import React from "react";
import Radium from "radium";

import styles from "./AboutStyle";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import MailCapture from "../../components/Mail/Mail";

class About extends React.Component {
  render() {
    return (
      <div>
        <Navbar />
        <div className="container" style={styles.container}>
          <div className="row">
            <div className="col-xs-12 text-center" style={{ marginBottom: 50 }}>
              <h1 style={styles.aboutHeaderMain}>ABOUT US</h1>
            </div>
          </div>
          <div className="row" style={{ marginBottom: 50 }}>
            <div className="col-md-2 hidden-xs hidden-sm">
              <a style={styles.aboutLink} href="#mission">
                Our Mission
              </a>
              <a style={styles.aboutLink} href="#team">
                Founding Team
              </a>
            </div>
            <div className="col-md-10 col-xs-12">
              <div id="mission">
                <h3 style={styles.aboutHeader}>Our Mission</h3>
                <p style={{ textAlign: "justify" }}>
                  We at Aethilus constantly strive to enable our clients to outperform the competition and maintain leadership through our innovative solutions. These solutions have been built on
                  insights gained by our leadership team during their 30+ years of industry work experience at the ground level. We offer solutions for Enterprises as well as management executives.
                  Our solutions aim at co-creating value with our customers for our customers.
                </p>
              </div>
              <div id="team" style={styles.teamDiv}>
                <h3 style={styles.aboutHeader}>Founding Team</h3>
                <h4>CEO</h4>
                Deepak Jain has 32+ years of deep IT services area. He has served in various important leadership roles at Wipro Ltd over the past 30 years. To name a few:
                <ul>
                  <li> Global head of IT Infrastructure Services for Global markets </li>
                  <li> Global Head Work Force Planning and Development </li>
                  <li> Global Head of Internal Audit </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-10" style={{ marginBottom: 30, marginTop: 50 }}>
            <MailCapture />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Radium(About);



// WEBPACK FOOTER //
// ./src/containers/About/About.js